import type { AuthStore } from '@stores/auth/interfaces'
import type { AuthTokens } from '@brighterly/lib-core-types/login/interfaces'

import { lsAccessToken, lsRefreshToken, lsExpiresAt } from './storage'

const EXPIRY_SAFETY = 15 // seconds

export const _applyTokens = (state: AuthStore, payload: AuthTokens): void => {
  state.accessToken   = payload.access_token
  state.refreshToken  = payload.refresh_token
  state.tokenType     = payload.token_type
  state.expiresAt     = Date.now() + Math.max(0, (payload.expires_in - EXPIRY_SAFETY) * 1000)

  lsAccessToken.value   = state.accessToken
  lsRefreshToken.value  = state.refreshToken
  lsExpiresAt.value     = state.expiresAt
}
